// extracted by mini-css-extract-plugin
module.exports = {"container":"popUp-module--container--28U2U","box":"popUp-module--box--3Wjgy","close":"popUp-module--close--1NoBT","message":"popUp-module--message--AWhNP"};